import axios from 'axios';
import SessionStore from './stores/SessionStore';
// Using global SmarterElements from CDN script instead of import
let SmarterElementsInstance = null;

export let config = {
  //apiUrl: 'http://localhost:8011/v1',
  apiUrl: 'https://api.dev.smarterproctoring.com/v1',
  // sidUrl: 'http://localhost:8012/v1',
  sidUrl: 'https://api-stage.smarterid.com/v1',
  // coreApiUrl: 'http://localhost:8010/v1',
  coreApiUrl: 'https://api.dev.smarterservices.com/v1',
  domain: 'http://localhost:3000',
  ltiUrl: 'https://signon-stage.smarterservices.com',
  supportScriptUrl: 'https://help.dev.smarterservices.com/embed/in-app-widget.js',
  classCalcApiKey: 'sqlKeyMsCJsqCUPny8jIm27ZeJrPSrU_',
  mapsApiKey: 'AIzaSyBXUGDThYYVJOIcfKhKiUCbkQJz8LDVvXg',
  stripeApiKey: 'pk_test_KFciYfyySlhwTkFPpDmJEDYi',
  rbRedirect: 'http://localhost:3000/#/rb-complete',
  agreementUISrc: 'https://s3.amazonaws.com/smarterservices-static-staging/agreements-ui/js/agreements.min.js',
  instructorProctorTypeSid: 'TSc93c23e553ba4e2f9758e3f0649b667b',
  automatedProctorTypeSids: [
    'TS5f74ea3587a04a79b1a8e0697673f942',
    'TSe466bdd1eef94acaaa50e0df7cccceb3',
    'TS63dda27a6ba54c218449b934b7bb1ba8',
    'TS9531c6b112f145018dae3cd2a9f60c4c',
    'TS0f0c14b6fb734ff199afa93af8054ee2',
    'TS6d6011935f4646848ea4f7a29b4f61a5',
    'TS4b894875d26194988853e490dfb9bc41',
    'TSc93c23e553ba4e2f9758e3f0653ba4e2'

  ],
  defaultAutomatedPreset: 'MP5cf5b6711f784d5e810cf529cf21096f',
  playbackUrl: 'https://playback.dev.smarterproctoring.com',
  ldApiKey: '59edfdfd082f980b153ac148',
  logRocket: 'bkdp5p/smarterproctoring-stage',
  docsDomain: 'https://smarterproctoring.zendesk.com/hc/en-us/',
  gaCourse: 'UA-42156997-4',
  gaAdmin: 'UA-42156997-2',
  extensionId: 'njmamkocphdenkffaliamlfabafhmpjl',
  extensionUrl:
    'https://chrome.google.com/webstore/detail/smarterproctoring/jojmghhfemggnfdmnpihldicgpjhigja',
  extensionManifestUrl:
    'https://smarterproctoring-extension.s3.amazonaws.com/test/config/manifest.json',
  sessionEndRedirectUrl: 'http://localhost:3000/#/automated/end-session',
  averageBrightnessMin: 0,
  desktopAppInfo:{
    widows: {
      downloadName: "SmarterServicesUtility_Setup.exe",
      url: 'http://localhost:5000/SmarterServicesUtility_latest_Setup.exe'
    },
    mac:{
      downloadName: "SmarterServicesUtility_Setup.dmg",
      url: 'http://localhost:5000/SmarterServicesUtility_latest_Setup.dmg'
    }
  },
  // URL of the webserver running inside the
  // desktop utility app - doesnt change across environments
  desktopAppBaseUrl: 'http://localhost:58729',
  // TEMP: Hard-code DMV installSids so we can
  // get the right agreement packages for them.
  dmvInstallSids: [
    'AI57d06cf3a5c44181ab5f141bf46e7ac4',
    'AIbde9a05b551d4e169a98d40bc1e59064'
  ]
};

// Flag local development so we can disable Atatus locally
if (!process.env.REACT_APP_ENVIRONMENT) {
  sessionStorage.setItem('local', true);
}

if (process.env.REACT_APP_ENVIRONMENT === 'production' || process.env.REACT_APP_ENVIRONMENT === 'production-b') {
  config.apiUrl = process.env.REACT_APP_ENVIRONMENT === 'production'
    ? 'https://api.smarterproctoring.com/v1'
    : 'https://api-b.smarterproctoring.com/v1';
  config.sidUrl = 'https://api.smarterid.com/v1';
  config.domain = 'https://app.smarterproctoring.com';
  config.ltiUrl = 'https://signon.smarterservices.com';
  config.coreApiUrl = 'https://api.smarterservices.com/v1';
  config.supportScriptUrl = 'https://help.smarterservices.com/embed/in-app-widget.js';
  config.rbRedirect = process.env.REACT_APP_ENVIRONMENT === 'production'
    ? 'https://app.smarterproctoring.com/#/rb-complete'
    : 'https://app-b.smarterproctoring.com/#/rb-complete';
  config.agreementUISrc = 'https://s3.amazonaws.com/cdn.smarterservices.com/agreements/js/agreements.min.js';
  config.instructorProctorTypeSid = 'TSc93c23e553ba4e2f9758e3f0649b667b';
  config.automatedProctorTypeSids = [
    'TS63dda27a6ba54c218449b934b7bb1ba8',
    'TS9531c6b112f145018dae3cd2a9f60c4c',
    'TS6d6011935f4646848ea4f7a29b4f61a5',
    'TS4b894875d26194988853e490dfb9bc41'
  ];
  config.defaultAutomatedPreset = 'MPc14acb87c9284cf1bc6572979f77fad2';
  config.playbackUrl = process.env.REACT_APP_ENVIRONMENT === 'production'
    ? 'https://playback.smarterproctoring.com'
    : 'https://playback-b.smarterproctoring.com';
  config.stripeApiKey = 'pk_live_A0FO1fJ61RdG68kSIPf9eNlG';
  config.ldApiKey = '55b25a2f133767270f000092';
  config.logRocket = 'bkdp5p/smarterproctoring-production';
  config.sessionEndRedirectUrl = process.env.REACT_APP_ENVIRONMENT === 'production'
    ? 'https://app.smarterproctoring.com/#/automated/end-session'
    : 'https://app-b.smarterproctoring.com/#/automated/end-session';
  config.desktopAppInfo = {
    widows: {
      downloadName: "SmarterServicesUtility_Setup.exe",
        url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases/windows/latest/SmarterServicesUtility_latest_Setup.exe'
    },
    mac:{
      downloadName: "SmarterServicesUtility_latest_Setup.dmg",
      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases/mac/latest/SmarterServicesUtility_latest_Setup.dmg'
    }
  };
}

if (process.env.REACT_APP_ENVIRONMENT === 'local') {
  config.apiUrl = 'http://localhost:8011/v1';
  config.coreApiUrl = 'http://localhost:8010/v1';
  config.sidUrl = 'https://api-stage.smarterid.com/v1';
  config.domain = 'http://localhost:3000';
  config.rbRedirect = 'http://localhost:3000/#/rb-complete';
  config.sessionEndRedirectUrl = 'http://localhost:3000/#/automated/end-session';
}

if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
  config.apiUrl = 'https://api.dev.smarterproctoring.com/v1';
  config.coreApiUrl = 'https://api.dev.smarterservices.com/v1';
  config.sidUrl = 'https://api-stage.smarterid.com/v1';
  config.domain = 'https://app.dev.smarterproctoring.com';
  config.rbRedirect = 'https://app.dev.smarterproctoring.com/#/rb-complete';
  config.sessionEndRedirectUrl =
    'https://app.dev.smarterproctoring.com/#/automated/end-session';
  config.desktopAppInfo = {
    widows: {
      downloadName: "SmarterServicesUtility_Setup.exe",
      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/windows/latest/SmarterServicesUtility_latest_Setup.exe'
    },
    mac:{
      downloadName: "SmarterServicesUtility_latest_Setup.dmg",
      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/mac/latest/SmarterServicesUtility_latest_Setup.dmg'
    }
  }
}

if (process.env.REACT_APP_ENVIRONMENT === 'sub') {
  config.apiUrl = 'https://api.sub.smarterproctoring.com/v1';
  config.sidUrl = 'https://api-stage.smarterid.com/v1';
  config.domain = 'https://app.sub.smarterproctoring.com';
  config.rbRedirect = 'https://app.sub.smarterproctoring.com/#/rb-complete';
  config.sessionEndRedirectUrl =
    'https://app.sub.smarterproctoring.com/#/automated/end-session';
  config.desktopAppInfo = {
    widows: {
      downloadName: "SmarterServicesUtility_Setup.exe",
      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/windows/latest/SmarterServicesUtility_latest_Setup.exe'
    },
    mac:{
      downloadName: "SmarterServicesUtility_latest_Setup.dmg",
      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/mac/latest/SmarterServicesUtility_latest_Setup.dmg'
    }
  }
}

if (process.env.REACT_APP_ENVIRONMENT === 'stage') {
  config.apiUrl = 'https://api.stage.smarterproctoring.com/v1';
  config.coreApiUrl = 'https://api.dev.smarterservices.com/v1';
  config.sidUrl = 'https://api.stage.smarterid.com/v1';
  config.domain = 'https://app.stage.smarterproctoring.com';
  config.rbRedirect = 'https://app.stage.smarterproctoring.com/#/rb-complete';
  config.playbackUrl = 'https://playback.stage.smarterproctoring.com';
  config.sessionEndRedirectUrl =
    'https://app.stage.smarterproctoring.com/#/automated/end-session';
  config.desktopAppInfo = {
    widows: {
      downloadName: "SmarterServicesUtility_Setup.exe",
      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/windows/latest/SmarterServicesUtility_latest_Setup.exe'
    },
    mac:{
      downloadName: "SmarterServicesUtility_latest_Setup.dmg",
      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/mac/latest/SmarterServicesUtility_latest_Setup.dmg'
    }
  }
}

if (process.env.REACT_APP_ENVIRONMENT === 'qa') {
  config.apiUrl = 'https://api-qa.smarterproctoring.com/v1';
  config.sidUrl = 'https://api.smarterid.com/v1';
  config.domain = 'https://app-qa.smarterproctoring.com/';
  config.ltiUrl = 'https://signon.smarterservices.com';
  config.rbRedirect = 'https://app-qa.smarterproctoring.com/#/rb-complete';
  config.agreementUISrc = 'https://s3.amazonaws.com/cdn.smarterservices.com/agreements/js/agreements.min.js';
  config.ldApiKey = '55b25a2f133767270f000092';
  config.instructorProctorTypeSid = 'TSc93c23e553ba4e2f9758e3f0649b667b';
  config.automatedProctorTypeSids = [
    'TS63dda27a6ba54c218449b934b7bb1ba8',
    'TS9531c6b112f145018dae3cd2a9f60c4c',
    'TS6d6011935f4646848ea4f7a29b4f61a5'
  ];
  config.defaultAutomatedPreset = 'MPc14acb87c9284cf1bc6572979f77fad2';
  config.playbackUrl = 'https://playback-qa.smarterproctoring.com';
  config.sessionEndRedirectUrl =
    'https://app-qa.smarterproctoring.com/#/automated/end-session';
  config.desktopAppInfo = {
    widows: {
      downloadName: "SmarterServicesUtility_Setup.exe",
      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/windows/latest/SmarterServicesUtility_latest_Setup.exe'
    },
    mac:{
      downloadName: "SmarterServicesUtility_latest_Setup.dmg",
      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/mac/latest/SmarterServicesUtility_latest_Setup.dmg'
    }
  }
}

export let api = axios.create({
  baseURL: config.apiUrl
});

export let sidApi = axios.create({
  baseURL: config.sidUrl
});

export let coreApi = axios.create({
  baseURL: config.coreApiUrl
});

// Initial sessionTimeout check (set to 120 so that it checks on load)
const sessionTimeout = 120;
let timeoutHandler = null;

// Make sure the timer doesn’t get created multiple times
let timerSet = false;

export function setToken(token, skipTtl) {
  api = axios.create({
    baseURL: config.apiUrl,
    headers: { token }
  });

  sidApi = axios.create({
    baseURL: config.sidUrl,
    headers: { token }
  });

  coreApi = axios.create({
    baseURL: config.coreApiUrl,
    headers: { token }
  });

  if (!skipTtl) {
    api.interceptors.response.use(function(config) {
      if (!timerSet) {
        // Create a new timer for session timeout
        createNewTimer(sessionTimeout / 1000, token);
      }

      return config;
    });
  }
}

// Create new session timeout timer
function createNewTimer(timeInSecond, token) {
  timerSet = true;

  setTimeout(function() {
    // Check how much time is left
    checkTtl(token)
      .then(res => {
        if (res <= 120 && res > 10) {
          // If 2 minutes or less remain, show the warning
          SessionStore.showExpireWarning();

          // Also start a new timer to expire the session if the user doesn’t extend
          timeoutHandler = createNewTimer(res + 120, token);
        } else if (res <= 10) {
          // If the session times out, expire it
          SessionStore.expireSession();
        } else {
          // Otherwise, create a new timer with the ttl response
          clearTimeout(timeoutHandler);
          SessionStore.removeExpireWarning();
          timeoutHandler = createNewTimer(res, token);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }, (timeInSecond - 120) * 1000);
}

// Check how much time is left
function checkTtl(token) {
  return new Promise((resolve, reject) => {
    const headers = {
      token: token
    };

    // axios.get(`./json/ttl.json`)
    //  .then(response => {
    //    return resolve(response.data.ttl)
    //  })
    //  .catch(error => {
    //    return resolve(-2)
    //  });

    api
      .get(`/ttl`, { headers })
      .then(response => {
        return resolve(response.data.ttl);
      })
      .catch(error => {
        return resolve(-2);
      });
  });
}

export const getSmarterElementsInstance = () => {
  if (!SmarterElementsInstance) {
    // set the environment based on where we are running. Switch through them
    let environment = 'local';
    switch (process.env.REACT_APP_ENVIRONMENT) {
      case 'local':
        environment = 'local';
        break;
      case 'dev':
        environment = 'development';
        break;
      case 'stage':
        environment = 'stage';
        break;
      case 'sub':
        environment = 'subenvironment';
        break;
      case 'production':
        environment = 'production';
        break;
      default:
        environment = 'local';
        break;
    }

    // Use the global SmarterElements variable from the CDN script
    if (window && window.SmarterElements) {
      try {
        SmarterElementsInstance = new window.SmarterElements({
          environment
        });
      }catch(e){
        console.error(e);
      }
    } else {
      console.error('SmarterElements not found. Make sure the CDN script is loaded properly.');
    }
  }
  return SmarterElementsInstance;
};


export const instructorProctorTypeSid = 'TSc93c23e553ba4e2f9758e3f0649b667b';



// WEBPACK FOOTER //
// ./src/app/config.js